import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import szLogo from '../assets/images/sz-logo-thickest.png'; // Import the new logo image

// Create a reusable Navigation component to ensure consistency across pages
const Navigation = ({ currentPage }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-charcoal-dark py-6">
      <div className="max-w-6xl mx-auto px-4 flex justify-between items-center">
        <Link to="/" className="font-cinzel text-2xl z-20 text-neon-blue flex items-center font-bold">
          <img src={szLogo} alt="Solypsizm Logo" className="h-8 mr-2" /> {/* Use the new logo image */}
          SOLYPSIZM
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-6">
          <Link to="/" className={currentPage === 'home' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}>Home</Link>
          <Link to="/about" className={currentPage === 'about' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}>About</Link>
          <Link to="/releases" className={currentPage === 'releases' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}>Releases</Link>
          <Link to="/social" className={currentPage === 'social' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}>Connect</Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden z-20 focus:outline-none"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 bg-charcoal-dark bg-opacity-95 z-10 flex flex-col items-center justify-center">
            <nav className="flex flex-col items-center space-y-8 text-xl">
              <Link
                to="/"
                className={currentPage === 'home' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}
                onClick={toggleMobileMenu}
              >
                Home
              </Link>
              <Link
                to="/about"
                className={currentPage === 'about' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}
                onClick={toggleMobileMenu}
              >
                About
              </Link>
              <Link
                to="/releases"
                className={currentPage === 'releases' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}
                onClick={toggleMobileMenu}
              >
                Releases
              </Link>
              <Link
                to="/social"
                className={currentPage === 'social' ? 'text-neon-blue' : 'hover:text-neon-blue transition-colors'}
                onClick={toggleMobileMenu}
              >
                Connect
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

// Create a reusable Footer component
const Footer = () => {
  return (
    <footer className="py-8 px-4 bg-charcoal-dark">
      <div className="max-w-6xl mx-auto">
        <p className="text-center text-gray-400">© 2026 Solypsizm Music, LLC. All rights reserved.</p>
      </div>
    </footer>
  );
};

export { Navigation, Footer };
